import type { FunctionComponent } from 'react';

import PaidByBankAccepted from './components/Accepted';
import PaidByBankFinished from './components/Finished';
import PaidByBankSatNote from './components/SatNote';
import usePaidByBank from './usePaidByBank';

const PaidByCard: FunctionComponent = () => {
  const { variant } = usePaidByBank();
  if (variant === 'finished') return <PaidByBankFinished />;
  if (variant === 'satnote') return <PaidByBankSatNote />;
  return <PaidByBankAccepted />;
};

export default PaidByCard;
